import { useCallback } from "react"
import { PropTypes } from "prop-types"

import useFastField from "../useFastField"
import TextAreaField from "."

export default function TextAreaFieldWrapper({ name, ...rest }) {
  const { field, error, helpers, touched } = useFastField(name)
  const { setValue } = helpers
  const onChange = useCallback((key, value) => setValue(value), [setValue])

  return (
    <TextAreaField
      {...field}
      error={error}
      onChange={onChange}
      touched={field.value ? touched : false}
      {...rest}
    />
  )
}

TextAreaFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired
}
